import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const DashboardCommunityPulse = ({ pulse, embedded = false }) => {
  const navigate = useNavigate();
  if (!pulse?.count || !pulse?.message) return null;

  return (
    <section className={embedded ? '' : 'mb-8'} aria-label="Community pulse">
      <div className={`flex flex-wrap items-center gap-3 p-4 ${embedded ? 'bento-card bento-card--compact' : 'bg-bone border border-hairline rounded-lg'}`}>
        <UserGroupIcon className="w-5 h-5 text-pine shrink-0" aria-hidden />
        <p className="text-label text-primary flex-1 min-w-[200px]">{pulse.message}</p>
        <button
          type="button"
          onClick={() => navigate(pulse.link || '/community')}
          className="text-label text-pine font-medium hover:underline shrink-0"
        >
          Join the conversation →
        </button>
      </div>
    </section>
  );
};

export default DashboardCommunityPulse;
